/**
 * One-shot "prompt to set a password on this arrival" signal (Q-506 card 1562).
 *
 * Raised by `usePasswordPromptOnArrival().promptIfNeeded` on a successful
 * arrival whose user has `passwordResetRequired`; consumed by the app-level
 * `PasswordPromptHost` (RootLayout), which shows the dialog over the page the
 * person lands on. In memory on purpose: a refresh or a later navigation does
 * not re-open it, because the signal is raised by the arrival, never derived
 * from `/me` on load.
 */
import { create } from 'zustand';
import { registerStoreReset } from './registry';

interface PasswordPromptState {
  pending: boolean;
  raise: () => void;
  clear: () => void;
}

export const usePasswordPromptStore = create<PasswordPromptState>((set) => ({
  pending: false,
  raise: () => set({ pending: true }),
  clear: () => set({ pending: false }),
}));

registerStoreReset(() => usePasswordPromptStore.setState({ pending: false }), {
  onUserSwitch: true, // the prompt belongs to the person it was raised for; a switch drops it, with no dismiss (#1686, Q-551)
});
